/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ActivatedThemesQueryVariables = Types.Exact<{
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
  type: Types.SurveyContentType;
}>;


export type ActivatedThemesQuery = { themes: Array<{ id: number, name: string, color: string, icon: string, lastUsedAt?: string | undefined, nextUsedAt?: string | undefined }> };


export const ActivatedThemesDocument = gql`
    query ActivatedThemes($limit: Int, $type: SurveyContentType!) {
  themes(limit: $limit, activatedOnly: true, type: $type) {
    id
    name
    color
    icon
    lastUsedAt
    nextUsedAt
  }
}
    `;

/**
 * __useActivatedThemesQuery__
 *
 * To run a query within a React component, call `useActivatedThemesQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivatedThemesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivatedThemesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useActivatedThemesQuery(baseOptions: Apollo.QueryHookOptions<ActivatedThemesQuery, ActivatedThemesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivatedThemesQuery, ActivatedThemesQueryVariables>(ActivatedThemesDocument, options);
      }
export function useActivatedThemesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivatedThemesQuery, ActivatedThemesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivatedThemesQuery, ActivatedThemesQueryVariables>(ActivatedThemesDocument, options);
        }
export type ActivatedThemesQueryHookResult = ReturnType<typeof useActivatedThemesQuery>;
export type ActivatedThemesLazyQueryHookResult = ReturnType<typeof useActivatedThemesLazyQuery>;
export type ActivatedThemesQueryResult = Apollo.QueryResult<ActivatedThemesQuery, ActivatedThemesQueryVariables>;